import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {computed} from 'vue';
import {DateRangeSearch} from '@/components/business/crud/interface/SearchType';
import dayjs, {Dayjs} from 'dayjs';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer";
import {ScForm} from "@/models/ScForm";


export default /*#__PURE__*/_defineComponent({
  __name: 'DateRangeSearch',
  props: {
    propName: {},
    widget: {},
    info: {}
  },
  setup(__props: any) {

const props = __props;

const data = ScForm.useFormData();

const ranges = {
  一天: [dayjs().subtract(1, 'd'), dayjs()],
  一周: [dayjs().subtract(1, 'w'), dayjs()],
  一个月: [dayjs().subtract(1, 'month'), dayjs()],
}
const showTime = {
    hideDisabledOptions: true,
    defaultValue: [
      dayjs('00:00:00', 'HH:mm:ss'),
      dayjs('23:59:59', 'HH:mm:ss'),
    ],
}
const value = computed({
  get() {
    const param: Dayjs[] = [];
    if (data.value[props.propName]?.$lte) {
      param.push(dayjs(Number(data.value[props.propName].$lte)));
    }
    if (data.value[props.propName]?.$gte) {
      param.push(dayjs(Number(data.value[props.propName].$gte)));
    }
    return param;
  },
  set(value: Dayjs[]) {
    const $gte = value ? value[0]?.valueOf() : undefined;
    const $lte = value ? value[1]?.valueOf() : undefined;
    if ($lte !== undefined || $gte !== undefined) {
      data.value[props.propName] = {
        $lte, $gte,
      }
    } else {
      data.value[props.propName] = undefined
    }
  },
})


return (_ctx: any,_cache: any) => {
  const _component_a_range_picker = _resolveComponent("a-range-picker")!

  return (_openBlock(), _createBlock(_component_a_range_picker, {
    style: {"width":"100%"},
    format: _ctx.widget.format,
    value: value.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
    separator: "-",
    showTime: showTime,
    disabled: _ctx.info.status === 'show',
    allowClear: true,
    ranges: ranges,
    placeholder: [_ctx.info.title + '开始', _ctx.info.title + '结束']
  }, null, 8, ["format", "value", "disabled", "placeholder"]))
}
}

})